var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_369_940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 14.0834H9.74967",
    stroke: "#888888",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17.3333V8.66663H16.25C16.8246 8.66663 17.3757 8.8949 17.7821 9.30123C18.1884 9.70756 18.4167 10.2587 18.4167 10.8333V11.9166C18.4167 12.4913 18.1884 13.0424 17.7821 13.4487C17.3757 13.855 16.8246 14.0833 16.25 14.0833H13",
    stroke: "#888888",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.667 8.66663V17.3333",
    stroke: "#888888",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74967 17.3333V11.375C9.74967 10.6567 9.46433 9.96779 8.95642 9.45988C8.44851 8.95197 7.75964 8.66663 7.04134 8.66663C6.32305 8.66663 5.63417 8.95197 5.12626 9.45988C4.61835 9.96779 4.33301 10.6567 4.33301 11.375V17.3333",
    stroke: "#888888",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_369_940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.dd0a736a3c513409adf40071cf16504a.svg";
export { ForwardRef as ReactComponent };